/* eslint-disable eol-last */
/* eslint-disable curly */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-var */
/* eslint-disable radix */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable prefer-const */
import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import {
  NavController,
  Platform,
  ModalController,
} from '@ionic/angular';
import { DrawerState } from 'ion-bottom-drawer';
import { GlobalVariable } from './global';
import { UserApiService } from './services/user-api.service';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { CONFIG } from './services/app-config.service';
import { RouterOutlet } from '@angular/router';
import { OrderTypeSelectionPage } from '../app/order-type-selection/order-type-selection.page';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  dockedHeight = 50;
  shouldBounce = true;
  disableDrag = false;
  distanceTop = 0;
  transition = '0.25s';
  state = DrawerState.Docked;
  minimumHeight = 60;
  places: any;
  queryParam: any = null;

  private destroy$ = new Subject<void>();

  constructor(
    private platform: Platform,
    private router: Router,
    private navCTRL: NavController,
    public globals: GlobalVariable,
    public server: UserApiService,
    public statusbar: StatusBar,
    private route: ActivatedRoute,
    public modalCtrl: ModalController
  ) {
    this.initializeApp();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const route = this.router.url;
        console.log('app', route);
        localStorage.setItem('prevRoute', route);
      }
    });
  }

  initializeApp() {
    this.geturlParamsOld();

    this.globals.hostName = window.location.hostname;

    // Only for testing on specific business
    if (this.globals.hostName !== 'localhost') {
      this.globals.inWeb = true;
      this.getHostData();
    } else {
      this.getbusiness();
    }

    const width = window.innerWidth;
    if (width > 1199) {
      this.globals.phoneView = false;
    }

    const isOnline = navigator.onLine;
    if (!isOnline) {
      this.globals.presentToast('Offline');
    }

    if (!this.globals.inWeb) {
      this.navCTRL.navigateRoot('splash');
    }

    this.platform.ready().then(() => {
      this.statusbar.overlaysWebView(false);
      if (window.statusbar) {
        this.statusbar.show();
      }
      this.getTheme();
    });
  }

   listenToNavigation() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.getUrlParams();
      }
    });
  }

  getUrlParams() {
    let queryParam = {};
    let orderFrom = null;
    let menuId = null;

    // Use window.location.search every time for consistency
    const urlParams = new URLSearchParams(window.location.search);

    orderFrom = urlParams.get('order_from');
    menuId = urlParams.get('menu_id');

    // Handle order_from
    if (orderFrom === 'school') {
      queryParam = { ...queryParam, order_from: orderFrom };
      sessionStorage.setItem('orderFrom', orderFrom);

      const popVal = JSON.parse(sessionStorage.getItem('showInfoPopup'));
      if (popVal !== false) {
        sessionStorage.setItem('showInfoPopup', JSON.stringify(true));
      }
    } else {
      sessionStorage.removeItem('orderFrom');
    }

    // Handle menu_id
    if (menuId) {
      queryParam = { ...queryParam, menu_id: menuId };
      sessionStorage.setItem('menu_id', menuId);
      console.log('Saved menu_id:', menuId);
    } else {
      // If menu_id missing, remove from storage
      sessionStorage.removeItem('menu_id');
      console.log('Removed menu_id because none in URL.');
    }

    this.queryParam = queryParam;
    console.log('Live queryParams:', this.queryParam);
  }


  geturlParamsOld() {
    let queryParam = {};
    this.route.queryParams.subscribe((params) => {
      // Try to get from Angular first
      let orderFrom = params['order_from'];
      let menuId = params['menu_id'];

      // Fallback to window.location if not present
      if (!orderFrom || !menuId) {
        const urlParams = new URLSearchParams(window.location.search);
        if (!orderFrom) {
          orderFrom = urlParams.get('order_from');
        }
        if (!menuId) {
          menuId = urlParams.get('menu_id');
        }
      }

      // Handle order_from
      if (orderFrom === 'school') {
        queryParam = { ...queryParam, order_from: orderFrom };
        this.queryParam = queryParam;
        sessionStorage.setItem('orderFrom', orderFrom);

        const popVal = JSON.parse(sessionStorage.getItem('showInfoPopup'));
        if (popVal !== false) {
          sessionStorage.setItem('showInfoPopup', JSON.stringify(true));
        }
      }

      // Handle menu_id
      if (menuId) {
        queryParam = { ...queryParam, menu_id: menuId };
        this.queryParam = queryParam;
        sessionStorage.setItem('menu_id', menuId);
      }

      // Assign final queryParam to global if needed
      this.queryParam = queryParam;
      console.log('Live queryParams', this.queryParam);

    });
  }

  getTheme() {
    const isDarkTheme = localStorage.getItem('darktheme');
    if (isDarkTheme === 'true') {
      document.body.classList.toggle('dark', true);
      this.statusbar.backgroundColorByHexString('#000000');
      this.statusbar.styleLightContent();
    } else {
      document.body.classList.toggle('light', true);
      this.statusbar.backgroundColorByHexString('#ffffff');
      this.statusbar.styleDefault();
    }
  }

  // For web
  async getHostData() {
    this.server.getHostInfo().subscribe(async (res) => {
      console.log('data from host api', res.business_id);
      this.globals.webMetaData = res;
      CONFIG.business_id = res.business_id;
      CONFIG.business_username = res.username;
      CONFIG.splash_image = res.logo;
      CONFIG.splash_text = res.name;
      this.globals.header_data = res?.header_data;
      this.globals.footer_data = res?.footer_data;

      this.getbusiness();
    });
  }

  getWelcomeBanners() {
    this.server.welcomeBanners().subscribe((res) => {
      console.log('welcome banner', res);
      this.globals.welcomeTitle = res.welcome_screen_title;
      this.globals.welcomeSubtitle = res.welcome_screen_subtitle;
      this.globals.banner_image = `url(${res.welcome_screen_image}) 100% 100%/100%`;
    });
  }

  getbusiness() {
    this.globals.tempID = CONFIG.business_id;

    // Check for remembered branch
    const remember = localStorage.getItem('remember_branch');
    if (remember === 'true') {
      console.log('remember branch............');
      const busID = localStorage.getItem('activeBranchid');
      if (busID != null && busID !== 'null') {
        console.log('saved branch id');
        CONFIG.business_id = busID;
        this.globals.branch_enabled = 0;
      }
    }
    console.log('serviceId', CONFIG.business_id);

    this.server.getBusiness().subscribe((res) => {
      console.log('business', CONFIG.business_id);
      console.log('datattt', res.results[0]);

      if (res.status === 'true') {
        this.processBusinessData(res.results[0]);
      }
    });
  }

  private processBusinessData(businessData: any) {
    this.globals.businessData = businessData;
    this.globals.businessName = businessData.name;
    this.globals.businessId = businessData.business_id;
    this.globals.qrEnabled = businessData?.app_qr ?? true;
    console.log('app qr', this.globals.qrEnabled);

    // Set all business properties
    this.setBusinessProperties(businessData);

    // Set document title and favicon
    document.getElementById('title').innerHTML = businessData.name;
    const favicon = document.getElementById('favicon_main');
    favicon.setAttribute('href', this.globals.b_logo);

    // Set boolean flags
    this.setBooleanFlags(businessData);

    if (this.globals.inWeb) {
      this.getParamsFromUrl();
      this.getCategories();
    }

    this.loadBanner();

    if (businessData.appColor) {
      console.log('app color is ....', businessData.appColor);
      this.globals.appColor = businessData.appColor;
      document.documentElement.style.setProperty(
        '--ion-color-primary',
        this.globals.appColor
      );
    }
  }

  private setBusinessProperties(data: any) {
    // Simplified property assignments
    const properties = {
      point_check: 'points_enabled',
      MenuStyle: 'menu_style',
      punch_check: 'punches_enabled',
      special_offer: 'special_offer',
      events_enabled: 'events_enabled',
      dineInEnabled: 'dine_in',
      gallery_enabled: 'gallery_enabled',
      pickup: 'pickup',
      franchise_enabled: 'franchise_enabled',
      b_type: 'b_type',
      businessHost: 'marketing_url[0]',
      latitude: 'latitude',
      longitude: 'longitude',
      menu_ready_msg: 'menu_ready_message',
      hours_operation: 'hours_operation',
      branch_enabled: 'branch_enabled',
      giftcard_enabled: 'giftcard_enabled',
      b_logo: 'logo',
      home_logo: 'logo',
      business_name: 'name',
      business_phone: 'phone',
      business_address: 'address',
      StripId: 'stripe_id',
      order_instructions: 'instructions_enabled',
      pickup_timing: 'pickup_timing',
      delivery_timing: 'delivery_timing',
      business_username: 'username',
      estimated_time: 'delivery_time',
      business_discount_count: 'business_discount_count',
      username: 'username',
      bussinessId: 'business_id',
      admin_stripe: 'admin_stripe_enabled',
      pickupsetting: 'delivery_time',
      tax: 'tax',
      deliveryCharges: 'delivery_fee',
      cardDeliveryFee: 'card_delivery_fee',
      pickup_Time: 'pickup_time',
      minimun_order: 'minimum_order',
      availed_discount_count: 'customer_discount_availed_count',
      paypalId: 'paypal_id',
      Timing: 'hours_operation',
      specific_delivery_day: 'specific_delivery_day',
      review_enabled: 'review_enabled',
      delivery_day: 'delivery_day',
      authorize_enabled: 'authorize_enabled',
      card_enabled: 'card_enabled',
      admin_stripe_enabled: 'admin_stripe_enabled',
      catering_enabled: 'catering_enabled',
      catering_cart_enabled: 'catering_cart_enabled',
      giftcard_amount_limit: 'giftcard_limit',
      business_type: 'business_type',
      appointment_enabled: 'appointment_enabled',
      website: 'website',
      orders_enabled: 'orders_enabled',
      BusinessDiscount: 'discount',
      ccFeeDisclaimer: 'ccFeeDisclaimer',
      tip_enabled: 'tip_enabled',
      menu_ready: 'menu_ready',
      delivery_time: 'delivery_time',
      doordashEnabled: 'doordash_enabled',
      loyaltyEnabled: 'loyalty',
      reservationEnabled: 'reservation',
      platformFeeEnabled: 'platformFeeEnabled',
      platformFeeAmount: 'platformFeeAmount',
      platformFeeLabel: 'platformFeeLabel',
      schedule_enabled: 'schedule_enabled',
      display_menu: 'display_menu'
    };

    Object.entries(properties).forEach(([globalProp, dataProp]) => {
      const path = dataProp.split('.');
      let value = data;

      for (const p of path) {
        if (p.includes('[') && p.includes(']')) {
          const arrayPath = p.split('[');
          const propName = arrayPath[0];
          const index = parseInt(arrayPath[1].replace(']', ''));
          value = value[propName][index];
        } else {
          value = value[p];
        }

        if (value === undefined) break;
      }

      if (value !== undefined) {
        if (globalProp === 'business_discount_count' ||
          globalProp === 'minimun_order' ||
          globalProp === 'availed_discount_count' ||
          globalProp === 'BusinessDiscount') {
          this.globals[globalProp] = parseInt(value);
        } else {
          this.globals[globalProp] = value;
        }
      }
    });
  }

  private setBooleanFlags(data: any) {
    const booleanFlags = {
      pickup: data.pickup === '1',
      delivery: data.delivery === '1',
      cash_enabled: data.cash_enabled === '1'
    };

    Object.assign(this.globals, booleanFlags);
  }

  loadBanner() {
    this.server.LoadBanners().subscribe(
      (data) => {
        this.globals.isDataLoaded = true;
        this.globals.bannerSliderImages = data.data.map(item => item.image);

        // Set banner-related properties
        const bannerProps = {
          banner_color: 'banner_color',
          giftCard_color: 'gift_cards_color',
          myRewards_color: 'my_rewards_color',
          orderNow_color: 'order_now_color',
          specialOffer_color: 'special_offer_color',
          themeColor: 'theme_color',
          cash_discount: 'cash_discount',
          banners: 'data',
          ring_image: 'ring_image',
          cash_discount_enabled: 'cash_discount_enabled',
          cash_discount_percentage: 'cash_discount_percentage',
          cash_discount_value: 'cash_discount_value'
        };

        Object.entries(bannerProps).forEach(([globalProp, dataProp]) => {
          this.globals[globalProp] = data[dataProp];
        });

        if (data.theme_color) {
          console.log('primary color ', data.theme_color);
          this.globals.appColor = data.theme_color;
          document.documentElement.style.setProperty(
            '--ion-color-primary',
            this.globals.appColor
          );
        }
      },
      (error) => {
        console.log('no network', error);
      }
    );
  }

  getCategories() {
    this.globals.superCategories = [];
    this.globals.Homecategories = [];

    this.server.getCategories().subscribe(
      (res) => {
        this.globals.dismiss();
        this.processCategories(res);
      },
      (err) => {
        this.globals.dismiss();
        this.globals.isDataLoaded = true;
        this.globals.presentToast('Network Error, try again');
      }
    );
  }

  private processCategories(res: any) {
    this.globals.scrollEvents = res.restaurant.app_menu;
    this.globals.superCategories = res.super_categories;

    const menu_id = this.globals.queryParamsFromUrl;

    if (menu_id?.menu_id) {
      this.processSpecificMenu(menu_id.menu_id);
    } else {
      this.processAllMenus();
    }

    this.handleCartAndNavigation();
  }

  private processSpecificMenu(menuId: string) {
    const targetCategory = this.globals.superCategories.find(
      cat => cat.id == menuId
    );

    if (targetCategory) {
      targetCategory.isAvailabe = this.checkTiming(targetCategory?.hours_operation);

      targetCategory.categories.forEach((category) => {
        category.isAvailabe = this.checkTiming(category?.timings);
        category.items.forEach((item) => {
          item.isAvailabe = this.checkTiming(item.item_timings);
        });
      });

      this.globals.Homecategories = targetCategory.categories;
      this.globals.activeSuperCatID = this.globals.Homecategories[0]?.category_id;
    }
  }

  private processAllMenus() {
    this.globals.superCategories.forEach((categories) => {
      categories.isAvailabe = this.checkTiming(categories?.hours_operation);
      categories.categories.forEach((category) => {
        category.isAvailabe = this.checkTiming(category?.timings);
        category.items.forEach((item) => {
          item.isAvailabe = this.checkTiming(item.item_timings);
        });
      });
    });

    if (this.globals.superCategories.length > 0) {
      this.globals.Homecategories = this.globals.superCategories[0]?.categories;
      this.globals.activeSuperCatID = this.globals.Homecategories[0]?.category_id;
    }
  }

  private handleCartAndNavigation() {
    this.globals.orderOnCall = JSON.parse(localStorage.getItem('orderOnCall'));

    if (this.globals.inWeb) {
      const cartData = localStorage.getItem('cart');
      console.log('items in storage', cartData);

      if (cartData && cartData !== 'null' && cartData !== 'undefined') {
        this.globals.itemsInCart = JSON.parse(cartData);
      }
    }

    if (!this.globals.queryParamsFromUrl?.type) {
      console.log('query params', this.queryParam);
      const path = window.location.pathname;
      const redirect = path === '/gift-cards' ? 'gift-cards' : 'order';

      this.router.navigate([redirect], {
        replaceUrl: true,
        queryParams: this.queryParam,
      }).then((res) => {
        if (this.globals.orderOnCall) {
          this.orderTypePage();
        }
      });

      this.time_change();
    } else {
      const path = window.location.pathname;
      const redirect = path === '/gift-cards' ? 'gift-cards' : 'order';

      this.router.navigate([redirect], {
        replaceUrl: true,
        queryParams: this.queryParam,
      });
    }
  }

  async orderTypePage() {
    const modal = await this.modalCtrl.create({
      component: OrderTypeSelectionPage,
      cssClass: 'orderTypeModal',
      mode: 'ios',
      backdropDismiss: false,
      swipeToClose: false,
    });

    await modal.present();

    modal.onDidDismiss().then((data) => {
      console.log(data);
    });
  }

  checkTiming(Timing) {
    if (!Timing) return true;

    let day: number;
    let time: number;

    const scheduled_time_ = localStorage.getItem('scheduled_time');

    if (this.globals.order_time === 'schedule' && scheduled_time_ && scheduled_time_ !== 'null') {
      day = this.globals.s_day;
      time = this.globals.s_time;
    } else {
      const date = new Date();
      day = date.getDay();
      time = parseFloat(`${date.getHours()}.${date.getMinutes()}`);
    }

    if (day === 7) day = 0;

    const current_day = Timing[day];
    if (!current_day) return true;

    // Normalize time values (e.g., convert "9.30" to "9.3")
    const normalizedTimes = current_day.map(t => {
      if (typeof t === 'string' && t.includes('.')) {
        const [hours, minutes] = t.split('.');
        return parseFloat(`${hours}.${minutes.substring(0, 1)}`);
      }
      return t === 'opened' ? 0 : parseFloat(t);
    });

    const [openTime, closeTime] = normalizedTimes;

    if (openTime === 0 && closeTime === 0) return true; // "opened"

    return (openTime <= time && closeTime > time) ||
      (openTime <= time && closeTime < openTime);
  }

  time_change() {
    const scheduled_time_ = localStorage.getItem('scheduled_time');
    if (!scheduled_time_ || scheduled_time_ === 'undefined') {
      console.log('time not scheduled');
      return;
    }

    this.server.date_convert(scheduled_time_).subscribe(
      (data) => {
        console.log('.............', data);
        if (data.success === true) {
          this.globals.s_day = data.day_id + 1;
          this.globals.s_time = data.time;
        }
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  getParamsFromUrl() {
    if (!this.globals.inWeb) return;

    this.globals.queryParamsFromUrl = this.route.snapshot.queryParams;
    console.log('query params', this.route.snapshot.queryParams);
  }
}